import { Spin } from 'antd';
import type { OoCaseSidebarContext } from 'components/CaseSidebar/buildOoCaseSidebar';
import { CaseSidebarItemId } from 'components/CaseSidebar/types';
import { FormValidationProvider } from 'hooks';
import { BtlBaseForm } from 'pages/BtlApplicationFormPage/BtlBaseForm';
import { useNavigate } from 'react-router-dom';
import { OoCaseFormFooter } from '../OoCaseFormFooter';
import { isOoPropertyFormEditable, useOoCasePropertyForm } from './useOoCasePropertyForm';

interface CasePropertyPageProps {
  caseId: string;
  sidebarContext: OoCaseSidebarContext;
}

function CasePropertyPageContent({ caseId, sidebarContext }: CasePropertyPageProps) {
  const navigate = useNavigate();
  const form = useOoCasePropertyForm({ caseId, sidebarContext });

  const handleNavigate = (itemId: CaseSidebarItemId) => {
    navigate({ search: `?section=${itemId}` });
  };

  if (form.isLoading) {
    return <Spin size='large' />;
  }

  return (
    <BtlBaseForm
      key={form.formKey}
      {...form.formProps}
      submitter={
        form.isFormEditable
          ? {
              render: ({ form: antForm }) => (
                <OoCaseFormFooter {...form.footerProps} form={antForm} isFormEditable onNavigate={handleNavigate} />
              ),
            }
          : false
      }
    />
  );
}

export function CasePropertyPage(props: CasePropertyPageProps) {
  return (
    <FormValidationProvider>
      <CasePropertyPageContent {...props} />
    </FormValidationProvider>
  );
}

export { isOoPropertyFormEditable };
